import { render, staticRenderFns } from "./AboutTheWorldWrapper.vue?vue&type=template&id=3fe1284c&lang=pug&"
import script from "./AboutTheWorldWrapper.vue?vue&type=script&lang=js&"
export * from "./AboutTheWorldWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports